import { render, staticRenderFns } from "./EditAndDeleteTool.vue?vue&type=template&id=b703a874&scoped=true&"
import script from "./EditAndDeleteTool.vue?vue&type=script&lang=js&"
export * from "./EditAndDeleteTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b703a874",
  null
  
)

export default component.exports